import { useMutation } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { ProjectReviewVisitV2Screen_OverrideWeatherAutoValidationDocument } from "../mutations.generated";

export function useProjectReviewVisitV2WeatherReportsRoute_OverrideAutoValidation(visitId: string) {
    const [overrideWeatherAutoValidationMutation, { loading, error }] = useMutation(
        ProjectReviewVisitV2Screen_OverrideWeatherAutoValidationDocument,
    );

    return {
        handleOverrideWeatherAutoValidation: async (reason: string | null) => {
            await overrideWeatherAutoValidationMutation({
                variables: {
                    input: {
                        plannerVisitId: visitId,
                        weatherProtocolAutoValidationOverriddenAt: reason ? parseDateToString(new Date()) : null,
                        weatherProtocolAutoValidationOverriddenReason: reason,
                    },
                },
            });
        },
        loading,
        error,
    };
}
